export default {
    type: 'hero-contact',
    name: 'Hero Contact',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleHeroContact',
            loader: () => import('./ModuleHeroContact')
        },
        form: {
            name: 'ModuleHeroContactForm',
            loader: () => import('./ModuleHeroContactForm')
        }
    }
};
